export const getBedrooms = (bedrooms: number | null) => {
  if (bedrooms === null) return "";
  return `${bedrooms} sovrum`;
};
